module.exports = __webpack_public_path__ + "img/banner_11.d03189cc.jpg";